module.exports = "<div ng-class=\"['menu-icon-wrap', {open: $ctrl.menuOpened}]\" ng-click=\"$ctrl.toggleOpenState()\">\n  <div class=\"menu-icon\">\n    <span></span>\n    <span></span>\n    <span></span>\n    <span></span>\n  </div>\n  <!-- .menu-icon END -->\n</div>\n<!-- .menu-icon-wrap END -->\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/adpMenuToggler/adpMenuToggler.html
// module id = 561
// module chunks = 0